import { render, staticRenderFns } from "./ArrivalOrder.vue?vue&type=template&id=9b15d720&scoped=true"
import script from "./ArrivalOrder.vue?vue&type=script&lang=js"
export * from "./ArrivalOrder.vue?vue&type=script&lang=js"
import style0 from "./ArrivalOrder.vue?vue&type=style&index=0&id=9b15d720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b15d720",
  null
  
)

export default component.exports